import { Route, Routes } from 'react-router-dom';

import AdminPanel from 'containers/AdminPanel';
import Announcements from 'containers/Announcements';
import Committee from 'containers/Committee';
import ContactDetails from 'containers/ContactDetails';
import Contacts from 'containers/Contacts';
import FourNotFour from 'containers/FourNotFour';
import useAuth from 'hooks/useAuth';
import { ROUTES_MAPPING } from 'utils/constants';

const AppRoutes = () => {
  const { isAdmin } = useAuth();

  return (
    <Routes>
      <Route path={ROUTES_MAPPING.contacts} element={<Contacts />} />
      <Route path={ROUTES_MAPPING.contactDetails} element={<ContactDetails />} />
      <Route path={ROUTES_MAPPING.committee} element={<Committee />} />
      <Route path={ROUTES_MAPPING.announcements} element={<Announcements />} />
      <Route path={ROUTES_MAPPING.admin} element={isAdmin ? <AdminPanel /> : <FourNotFour />} />
      <Route path="*" element={<FourNotFour />} />
    </Routes>
  );
};

export default AppRoutes;
